import { useLocalStorageState } from "./useLocalStorageState";
import { useIsDesktopBrowser } from "./useIsDesktopBrowser";

export function useShowThreadInfoPanel() {
  const isDesktop = useIsDesktopBrowser();
  return useLocalStorageState(`thread`, `showThreadInfoPanel`, isDesktop);
}
